import React from 'react'
import Layout from '../Layouts/Layout'
import db from '../db'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function Courses(){
  window.scroll(0,0);
    return (
      <Layout>
        <Helmet>
          <title>Təlimlər | Kodart Tətbiq və Təlim Mərkəzi</title>
          <meta name="description" content="Kodart Tətbiq və Təlim Mərkəzinin proqramlaşdırma kursları: Scratch, Python, veb-proqramlaşdırma və data elm." />
          <link rel="canonical" href="https://kodart.az/təlimlər" />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="az_AZ" />
          <meta property="og:url" content="https://kodart.az/təlimlər" />
          <meta property="og:title" content="Təlimlər | Kodart" />
          <meta property="og:description" content="Kodart Tətbiq və Təlim Mərkəzinin proqramlaşdırma kursları." />
          <meta property="og:image" content="https://kodart.az/android-chrome-512x512.png" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Təlimlər | Kodart" />
          <meta name="twitter:description" content="Kodart Tətbiq və Təlim Mərkəzinin proqramlaşdırma kursları." />
          <meta name="twitter:image" content="https://kodart.az/android-chrome-512x512.png" />
        </Helmet>
        <main data-page='courses'>
        <section className='section-container training-section'>
          <div className='section-header'>
            <h1>Təlimlərimiz</h1>
            <div className='green-dot-line'></div>
          </div>
          <div className='row'>
            {db.courses.sort((a,b) => +a.id - +b.id).map(c => {
              return (
                <div key={c.id} className='col-12 col-sm-6 col-md-3'>
                  <div className='course-card'>
                    <img className='card-icon' src={c.image} alt={c.name}/>
                    <h2><span className="prefix">{c.prefix}:</span> {c.name}</h2>
                    <p className='course-description'>{c.description}</p>
                    <Link to={`/təlim/${c.title}`} className='more-info-button'>
                      Ətraflı məlumat
                    </Link>
                  </div>
                </div>
              )
            })}
          </div>
        </section>
        {/* <Call/> */}
        </main>
      </Layout>
    )
}